import { Component } from '@angular/core';
import { Provinces } from '../../../constantes/provinces.enum';
import { environment } from '../../../../environments/environment';
import { PCA, PCAAddressField, PCAFieldMode, PCAResult } from '../../../models/poste-canada';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { ErreurMappingService } from '../../../services/errors/erreur-mapping.service';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { SaisieComponent } from '../saisie.component';
import { TypeChangementEnum } from '../../../constantes/type-changement.enum';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { AccessibiliteService } from '../../../services/accessibilite.service';
import { LangueService } from 'src/app/services/langue/langue.service';

declare let pca: PCA;

@Component({
  selector: 'app-saisie-adresse',
  templateUrl: './saisie-adresse.component.html',
  styleUrls: ['./saisie-adresse.component.scss'],
  standalone: false,
})
export class SaisieAdresseComponent extends SaisieComponent {
  listeProvince: string[] = [...Object.keys(Provinces)];

  private controlCAInitialised = false;

  constructor(
    erreurMappingService: ErreurMappingService,
    globalStoreService: GlobalStoreService,
    navigationService: NavigationService,
    cybermetrieCoordonneesService: CybermetrieCoordonneesService,
    accessibiliteService: AccessibiliteService,
    langueService: LangueService
  ) {
    super(
      erreurMappingService,
      globalStoreService,
      navigationService,
      cybermetrieCoordonneesService,
      accessibiliteService,
      langueService,
      TypeChangementEnum.COORDONNEES
    );
  }

  configAutoCompleteAdressCanada(): void {
    if (!this.controlCAInitialised) {
      this.initializeControlCA();
    }
  }

  initializeControlCA(): void {
    this.controlCAInitialised = true;
    const currentLang = this.langueService.getCurrentLanguage();
    const fieldsCA: PCAAddressField[] = [{ element: 'rueCanada', field: 'Line1', mode: PCAFieldMode.SEARCH }];
    const options = {
      key: environment.keyPosteCanada,
      culture: currentLang + '-CA',
      name: 'champRechercheAddressPosteCanada',
      languagePreference: currentLang === 'en' ? 'eng' : 'fra',
      maxItems: 4,
    };
    const controlCA = new pca.Address(fieldsCA, options);
    controlCA.setCountry('CA');
    controlCA.listen('populate', (address: PCAResult) => this.miseAjourDeLAdresse(address));
  }

  miseAjourDeLAdresse(adresse: PCAResult): void {
    this.controleFormGroup?.get('rueCanada')?.setValue(this.extractLigne1(adresse));
    this.controleFormGroup?.get('appartementCanada')?.setValue(adresse.SubBuilding || null);
    this.controleFormGroup?.get('villeCanada')?.setValue(adresse.City || null);
    this.controleFormGroup?.get('provinceCanada')?.setValue(this.extractProvince(adresse.ProvinceCode));
    this.controleFormGroup?.get('codePostalCanada')?.setValue(adresse.PostalCode || null);
  }

  private extractLigne1(adresse: PCAResult): string {
    return `${adresse.BuildingNumber} ${adresse.Street}`;
  }

  private extractProvince(province: string): string | null {
    return this.listeProvince.includes(province) ? province : null;
  }
}
